import { useTags } from "../../../../hooks/queries/use-tags";

const FALLBACK_QUICK_SEARCHES = [
  "Treatment",
  "Medication",
  "Diagnosis",
  "Imaging",
  "Surgical history",
  "Functional capacity",
  "Prognosis",
  "Work capacity",
  "Prior injuries",
  "Clinical findings",
];

type QuickSearchesProps = {
  onSelect: (label: string) => void;
  title?: string;
  centered?: boolean;
};

export const QuickSearches = ({
  onSelect,
  title = "Quick searches:",
  centered = false,
}: QuickSearchesProps) => {
  const { data: tags, isLoading } = useTags();
  const labels = tags?.map((t) => t.name) ?? FALLBACK_QUICK_SEARCHES;

  return (
    <div className={centered ? "flex flex-col items-center" : undefined}>
      <h3 className="mb-2 text-xs font-medium text-foreground-muted">{title}</h3>
      <div className={`flex flex-wrap gap-1.5 ${centered ? "justify-center" : ""}`}>
        {isLoading
          ? Array.from({ length: 5 }).map((_, i) => (
              <div
                key={i}
                className="h-7 w-20 animate-pulse rounded-full bg-gray-100"
              />
            ))
          : labels.map((label) => (
              <button
                key={label}
                onMouseDown={(e) => {
                  e.preventDefault();
                  onSelect(label);
                }}
                className="rounded-full bg-primary-50 px-3 py-1.5 text-xs font-normal text-primary transition-colors hover:bg-primary-100"
              >
                {label}
              </button>
            ))}
      </div>
    </div>
  );
};
